export default __webpack_public_path__ + "static/media/icon-folderSVG.a47cdec3.svg";